// src/pages/expense/cafe/ExpenseCafeGreenDraftList.jsx
// ✅ 전 사업 확산 [5] — 카페인 그린점 "지출목록" 페이지. 실제 로직은
// pages/expense/_shared/ExpenseDraftList.jsx(공통 컴포넌트)에 있고, 이 파일은
// 그린점 전용 config(greenDraftConfig.js)를 넘기는 얇은 래퍼일 뿐이다.
import React from "react";
import ExpenseDraftList from "../_shared/ExpenseDraftList";
import greenDraftConfig from "./greenDraftConfig";

export default function ExpenseCafeGreenDraftList() {
  return <ExpenseDraftList config={greenDraftConfig} />;
}
